"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const react_native_svg_1 = require("react-native-svg");
const PlusIcon = (props) => {
    const { width, height, color } = props;
    return (react_1.default.createElement(react_native_svg_1.Svg, { width: width, height: height, viewBox: "0 0 24 24" },
        react_1.default.createElement(react_native_svg_1.G, { id: "Components", stroke: "none", "stroke-width": "1", fill: "none", "fill-rule": "evenodd" },
            react_1.default.createElement(react_native_svg_1.G, { id: "Icons", transform: "translate(-588.000000, -1938.000000)" },
                react_1.default.createElement(react_native_svg_1.G, { id: "atom-/-icon-/-line-/-custom-/-plus", transform: "translate(588.000000, 1938.000000)" },
                    react_1.default.createElement(react_native_svg_1.Rect, { id: "Rectangle", x: "0", y: "0", width: "24", height: "24" }),
                    react_1.default.createElement(react_native_svg_1.Path, { d: "M12,4 C12.2454599,4 12.4496084,4.17687516 12.4919443,4.41012437 L12.5,4.5 L12.5,11.5 L19.5,11.5 C19.7761424,11.5 20,11.7238576 20,12 C20,12.2454599 19.8231248,12.4496084 19.5898756,12.4919443 L19.5,12.5 L12.5,12.5 L12.5,19.5 C12.5,19.7761424 12.2761424,20 12,20 C11.7545401,20 11.5503916,19.8231248 11.5080557,19.5898756 L11.5,19.5 L11.5,12.5 L4.5,12.5 C4.22385763,12.5 4,12.2761424 4,12 C4,11.7545401 4.17687516,11.5503916 4.41012437,11.5080557 L4.5,11.5 L11.5,11.5 L11.5,4.5 C11.5,4.22385763 11.7238576,4 12,4 Z", id: "Combined-Shape", fill: color }))))));
};
PlusIcon.defaultProps = {
    color: 'currentColor',
    width: 15,
    height: 15,
};
exports.default = react_1.default.memo(PlusIcon);
